export const platform = {
  WEB: "WEB",
  ANDROID: "ANDROID",
  IOS: "IOS",
  WINDOW: "WINDOW",
};
